// src/components/planning/EditSelectionsModal/services/placementService.ts

import apiClient from '../../../../utils/apiClient';

interface PlacementResponse {
  placements: string[];
}

export const searchPlacements = async (term: string): Promise<string[]> => {
  try {
    const response = await apiClient.get<PlacementResponse>(
      '/song-selections/search-placements',
      { params: { term } }
    );
    return response.data.placements;
  } catch (error) {
    console.error('Error searching placements:', error);
    return [];
  }
};